import React, { useEffect, useState } from 'react';
import './Products.css';
import Form from 'react-bootstrap/Form';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';

const ProductsPage = () => {
  const [sweets, setSweets] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [sortOption, setSortOption] = useState('default');
  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem('cartItems');
    return savedCart ? JSON.parse(savedCart) : [];
  });

  const navigate = useNavigate();

  // Fetch sweets data
  useEffect(() => {
    fetch('/sweets.json')
      .then(res => res.json())
      .then(data => setSweets(data.sweets))
      .catch(err => console.error('Sweets fetch error:', err));
  }, []);

  // Fetch categories data
  useEffect(() => {
    fetch('/categories.json')
      .then(res => res.json())
      .then(data => setCategories([{ slug: 'All', name: 'All' }, ...data.categories]))
      .catch(err => console.error('Categories fetch error:', err));
  }, []);

  // Save cart data to localStorage whenever cart changes
  useEffect(() => {
    localStorage.setItem('cartItems', JSON.stringify(cart));
  }, [cart]);

  // Filter sweets based on selected category
  let filteredSweets = selectedCategory === 'All'
    ? sweets
    : sweets.filter((sweet) => sweet.category === selectedCategory);

  // Sorting logic
  const handleSort = (a, b) => {
    if (sortOption === 'low-high') return a.price - b.price;
    if (sortOption === 'high-low') return b.price - a.price;
    if (sortOption === 'a-z') return a.name.localeCompare(b.name);
    if (sortOption === 'popularity') return (b.rating || 0) - (a.rating || 0);
    return 0;
  };

  filteredSweets = filteredSweets.sort(handleSort);

  // Add product to cart
  const addToCart = (product) => {
    setCart(prevCart => {
      const exists = prevCart.find((item) => item.id === product.id);
      let updatedCart;
      if (exists) {
        updatedCart = prevCart.map((item) =>
          item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
        );
      } else {
        updatedCart = [...prevCart, { ...product, quantity: 1 }];
      }
      return updatedCart;
    });
  };

  // Navigate to cart page
  const goToCart = () => {
    navigate('/cart');
  };

  return (
    <div className="container">
      <h1 className="header">All Products</h1>

      {/* Filter Section */}
      <div className="filter-container">
        {/* Category Filter */}
        <Form.Select
          className="select"
          onChange={(e) => setSelectedCategory(e.target.value)}
          value={selectedCategory}
        >
          {categories.map((item, index) => (
            <option key={index} value={item.slug}>{item.name}</option>
          ))}
        </Form.Select>

        {/* Sorting Filter */}
        <Form.Select
          className="select"
          onChange={(e) => setSortOption(e.target.value)}
          value={sortOption}
        >
          <option value="default">Sort By</option>
          <option value="low-high">Price: Low to High</option>
          <option value="high-low">Price: High to Low</option>
          <option value="popularity">Popularity</option>
          <option value="a-z">A-Z</option>
        </Form.Select>

        {/* Cart Button */}
        <button className="btn-success" onClick={goToCart}>
          🛒 Cart ({cart.reduce((acc, item) => acc + item.quantity, 0)})
        </button>
      </div>

      {/* Product Grid */}
      <div className="grid">
        {filteredSweets.map((sweet) => (
          <div key={sweet.id} className="product-card">
            <img src={sweet.image} alt={sweet.name} className="product-image" />
            <h5 className="product-title">{sweet.name}</h5>
            <p className="weight">1Kg</p>
            <div className="rating">
              ⭐⭐⭐⭐☆ <span className="rating-value">({sweet.rating || 4.5})</span>
            </div>
            <p className="product-description">{sweet.description}</p>
            <p className="price">Price: ₹{sweet.price}</p>
            <button className="btn-primary" onClick={() => addToCart(sweet)}>
              Add to Cart
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductsPage;
